var map = {
	"./metal.gif": "3OGz",
	"./pikachu.gif": "9fS0",
	"./rainbow.gif": "pu5I",
	"./wordart.gif": "PcGg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "S+BJ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/construction ^\.\/.*$
// module id = S+BJ
// module chunks = 0